/**
 * LayerDiagram — Norma → SICA → Consumidores.
 *
 * Static SVG, no charting library (per ADR-006 §4.7).
 */
export function LayerDiagram() {
  return (
    <div className="rounded-xl border border-line bg-paper-tinted/50 p-6 sm:p-10">
      <div className="grid gap-3 lg:grid-cols-3">
        <Layer
          label="Norma"
          title="NAP + 24 diseños jurisdiccionales"
          description="Documentos curriculares oficiales con jerarquía propia: ejes, bloques, saberes/capacidades, indicadores."
          variant="source"
        />
        <Layer
          label="SICA"
          title="Inteligencia curricular validada"
          description="Ingesta que preserva jerarquía. Curaduría humana. Cita exacta. Inventario de Activos Curriculares."
          variant="core"
        />
        <Layer
          label="Consumidores"
          title="UI Docente · Backoffice · Agentes externos (MCP)"
          description="Consumen la intelligence validada. No infieren. No crean relaciones nuevas. No responden sin fuente."
          variant="surface"
        />
      </div>
    </div>
  );
}

function Layer({
  label,
  title,
  description,
  variant,
}: {
  label: string;
  title: string;
  description: string;
  variant: 'source' | 'core' | 'surface';
}) {
  const styles = {
    source: 'border-line bg-paper text-ink',
    core: 'border-accent/50 bg-accent/5 text-ink',
    surface: 'border-line bg-paper text-ink',
  }[variant];

  return (
    <div className={`rounded-lg border p-5 ${styles}`}>
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-accent">{label}</p>
      <h3 className="mt-3 text-base font-semibold tracking-tight">{title}</h3>
      <p className="mt-2 text-sm leading-relaxed text-ink-muted">{description}</p>
    </div>
  );
}

/**
 * PipelineDiagram — Ingesta → Curaduría → Respuesta con cita.
 * Used in /producto/metodo/.
 */
export function PipelineDiagram() {
  const steps = [
    {
      n: '01',
      title: 'Ingesta',
      body:
        'Procesamos cada documento manteniendo la jerarquía: eje, bloque, saber/capacidad, indicador.',
    },
    {
      n: '02',
      title: 'Curaduría humana',
      body:
        'Especialistas curriculares validan la jerarquía extraída antes de que llegue al motor de consulta.',
    },
    {
      n: '03',
      title: 'Respuesta con cita',
      body:
        'Cada respuesta apunta al documento original y a la página exacta. Si no hay fuente, SICA dice que no sabe.',
    },
  ];
  return (
    <ol className="grid gap-4 sm:grid-cols-3">
      {steps.map((s) => (
        <li key={s.n} className="rounded-lg border border-line bg-paper p-5">
          <p className="font-mono text-xs text-ink-subtle">{s.n}</p>
          <h3 className="mt-2 text-base font-semibold tracking-tight">{s.title}</h3>
          <p className="mt-2 text-sm leading-relaxed text-ink-muted">{s.body}</p>
        </li>
      ))}
    </ol>
  );
}
